import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '@/pages/projects/useStewardshipFilter';
import REQUIRED_FIELDS_PUBLIC from '@/pages/projects/REQUIRED_FIELDS_PUBLIC';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10 } = props;

  const [timestamp] = useState(moment().toISOString());
  const [expireTimestamp] = useState(moment().add(21, 'days').toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('project.find', {
    where: {
      eager: {
        $aggregations: [
        {
          type: 'count',
          alias: 'numberOfQuestionsPending',
          relation: 'questions',
          $where: {
            response: 'Pending'
          }
        }],

        $where: {
          $and: REQUIRED_FIELDS_PUBLIC.$and,
          // numberOfQuestionsPending: {
          //   $lte: 0
          // },
          endDate: {
            $gte: timestamp,
            $lte: expireTimestamp
          },
          $or: stewardshipFilter
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}